import Microgame from '../engine/Microgame.js';

export default class SimonGame extends Microgame {

    static getPlayback() {
        return {
            title: { fr: `Mémoire !`, en: `Simon!`, es: `¡Memoria!` },
            controls: { fr: `Regarde bien l'ordre... puis touche les mêmes zones`, en: `Watch the order... then tap the same areas`, es: `Mira el orden... y luego toca las mismas áreas` },
            objective: { fr: `Reproduis la séquence exacte sans faire d'erreur`, en: `Reproduce the exact sequence without mistakes`, es: `Reproduce la secuencia exacta sin errores` },
            icon: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="var(--primary-color)" stroke-width="2"><path d="M21 12c0-4.97-4.03-9-9-9s-9 4.03-9 9 4.03 9 9 9 9-4.03 9-9Z"/><path d="M12 3v18"/><path d="M3 12h18"/></svg>`,
            actions: [
                { type: 'wait', duration: 1300 },
                { type: 'tapTarget', selector: '[data-index="0"]', duration: 180 },
                { type: 'wait', duration: 180 },
                { type: 'tapTarget', selector: '[data-index="1"]', duration: 180 },
                { type: 'wait', duration: 180 },
                { type: 'tapTarget', selector: '[data-index="2"]', duration: 180 },
                { type: 'wait', duration: 380 },
            ],
            loopDuration: 3000
        };
    }
    constructor(engine) {
        super(engine);
        this.sequence = [];
        this.playerSequence = [];
        this.buttons = [];
        this.colors = ['#ff0055', '#00f3ff', '#ccff00', '#ffcc00']; // Red, Blue, Green, Yellow (Neon)
        this.isPlayingSequence = false;
        this.step = 0;

        // Hide timer during demo
        this.hideTimer = true;
    }

    setup() {
        this.engine.ui.instruction.textContent = "WATCH!";

        // Grid container for buttons
        const grid = document.createElement('div');
        grid.style.display = 'grid';
        grid.style.gridTemplateColumns = '1fr 1fr';
        grid.style.gap = '20px';
        grid.style.width = '80%';
        grid.style.height = '60%';
        grid.style.position = 'absolute';
        grid.style.top = '50%';
        grid.style.left = '50%';
        grid.style.transform = 'translate(-50%, -50%)';
        this.container.appendChild(grid);

        // Create 4 buttons
        for (let i = 0; i < 4; i++) {
            const btn = document.createElement('div');
            btn.style.background = this.colors[i];
            btn.style.borderRadius = '10px';
            btn.style.opacity = '0.5';
            btn.style.boxShadow = `0 0 10px ${this.colors[i]}`;
            btn.style.cursor = 'pointer';
            btn.style.transition = 'opacity 0.1s, transform 0.1s';
            btn.dataset.index = i;

            // Touch feedback
            btn.addEventListener('pointerdown', (e) => {
                if (this.isPlayingSequence || !this.active) return;
                this.flashButton(i);
                this.handleInput(i);
            });

            grid.appendChild(btn);
            this.buttons.push(btn);
        }

        // Generate Sequence
        if (this.isPlayback) {
            this.sequence = [0, 1, 2];
        } else {
            const len = (this.engine.activeChallenge && this.engine.activeChallenge.config && this.engine.activeChallenge.config.sequenceLength) || 3;
            for (let i = 0; i < len; i++) {
                this.sequence.push(Math.floor(Math.random() * 4));
            }
        }

        // Play sequence after a short delay
        setTimeout(() => this.playSequence(), 500);
    }

    async playSequence() {
        this.isPlayingSequence = true;
        // Speed up demo: 200ms flash, 100ms wait
        for (let i = 0; i < this.sequence.length; i++) {
            if (!this.active) break;
            await this.wait(100);
            if (!this.active) break;
            await this.flashButton(this.sequence[i], 200);
        }
        this.isPlayingSequence = false;
        this.engine.ui.instruction.textContent = "REPEAT!";

        // Start timer NOW and make it visible
        this.hideTimer = false;
        if (this.engine.ui.timerFill && this.engine.ui.timerFill.parentElement) {
            this.engine.ui.timerFill.parentElement.style.display = 'block';
        }
    }

    flashButton(index, duration = 200) {
        return new Promise(resolve => {
            const btn = this.buttons[index];
            btn.style.opacity = '1';
            btn.style.transform = 'scale(0.95)';
            btn.style.boxShadow = `0 0 30px ${this.colors[index]}`;

            setTimeout(() => {
                btn.style.opacity = '0.5';
                btn.style.transform = 'scale(1)';
                btn.style.boxShadow = `0 0 10px ${this.colors[index]}`;
                resolve();
            }, duration);
        });
    }

    handleInput(index) {
        this.playerSequence.push(index);

        // Check correctness immediately
        const currentStep = this.playerSequence.length - 1;
        if (this.playerSequence[currentStep] !== this.sequence[currentStep]) {
            this.lose();
            return;
        }

        // Check win
        if (this.playerSequence.length === this.sequence.length) {
            this.win();
        }
    }

    wait(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
}
